export default __webpack_public_path__ + "static/media/Pasta Lock Branco.920b8458.png";